import { render, staticRenderFns } from "./ChangeFromUpdateMonth.vue?vue&type=template&id=6fb36b93"
import script from "./ChangeFromUpdateMonth.vue?vue&type=script&lang=js"
export * from "./ChangeFromUpdateMonth.vue?vue&type=script&lang=js"
import style0 from "./ChangeFromUpdateMonth.vue?vue&type=style&index=0&id=6fb36b93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports